import React, { useContext } from 'react';
import { Context } from 'components/Store';
import { FormikInput } from 'components/UiKit/FormikFields';

const ParcelNumber = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <FormikInput
      id="parcelNumber"
      name="parcelNumber"
      label="Parcel Number"
      placeholder="Enter parcel number"
      disabled={!isEnableInfoTabEdit}
    />
  );
};

export default ParcelNumber;
